import { createSlice } from '@reduxjs/toolkit';

import { handleGetDashboardOrgInfo } from './actions';
import { IDashboardOrgInfoState } from './slice.interface';

const initialState: IDashboardOrgInfoState = {
  data: null,
  stats: {
    medicationLookup: false,
    supplementInquiry: false,
    inquiryAdministration: false,
  },
  isLoading: false,
  isReady: false,
  error: false,
};

export const dashboardOrgInfoSlice = createSlice({
  name: 'dashboard-org-info',
  initialState,
  reducers: {
    removeDashboardOrgInfo: (state: IDashboardOrgInfoState) => {
      state.data = null;
      state.stats = {
        medicationLookup: false,
        supplementInquiry: false,
        inquiryAdministration: false,
      };
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetDashboardOrgInfo.pending, (state: IDashboardOrgInfoState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetDashboardOrgInfo.rejected, (state: IDashboardOrgInfoState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetDashboardOrgInfo.fulfilled, (state: IDashboardOrgInfoState, action) => {
        state.data = action.payload.data;
        if (action.payload.data.features) {
          state.stats = {
            medicationLookup: !!action.payload.data.features.find(
              f => f.name === 'MedicationLookup',
            ),
            supplementInquiry: !!action.payload.data.features.find(
              f => f.name === 'SupplementInquiry',
            ),
            inquiryAdministration: !!action.payload.data.features.find(
              f => f.name === 'InquiryAdministration',
            ),
          };
        }
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeDashboardOrgInfo } = dashboardOrgInfoSlice.actions;

export default dashboardOrgInfoSlice.reducer;
